(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jeje-edit-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jeje-edit-page')) {
    customElements.define('jeje-edit-page', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const cards = [...this.querySelectorAll('[data-edit-card]')];
        const select = this.querySelector('select');
        const filter = this.querySelector('[data-edit-filter]');
        const empty = this.querySelector('[data-edit-empty]');
        if (!select || !filter || !empty) return;
        const sizes = [...new Set([...this.querySelectorAll('[data-edit-size]')].map(el => el.dataset.editSize))];
        sizes.forEach(size => select.add(new Option(size, size)));
        filter.hidden = sizes.length === 0;
        const update = () => {
          cards.forEach(card => {
            card.hidden = select.value !== '' && ![...card.querySelectorAll('[data-edit-size]')].some(el => el.dataset.editSize === select.value);
          });
          empty.hidden = cards.some(card => !card.hidden);
        };
        select.addEventListener('change', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeje-last-pieces"] && !Shopify.designMode) return;
  try {
    
  function initJejeLast(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('.jeje-last__card')];
    const select = root.querySelector('select');
    const sizes = [...new Set([...root.querySelectorAll('[data-lp-size]')].map(el => el.dataset.lpSize))];
    sizes.forEach(size => select.add(new Option(size, size)));
    root.querySelector('.jeje-last__filter').hidden = sizes.length === 0;
    const update = () => {
      cards.forEach(card => { card.hidden = select.value !== '' && ![...card.querySelectorAll('[data-lp-size]')].some(el => el.dataset.lpSize === select.value); });
      root.querySelector('.jeje-last__empty').hidden = cards.some(card => !card.hidden);
    };
    select.addEventListener('change', update);
    update();
  }
  document.querySelectorAll('[data-jeje-last]').forEach(initJejeLast);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jeje-last]').forEach(initJejeLast));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
